import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/tabeladesconto?${serialize(filtros)}`, { tela: 'tabela_desconto' })
}

export async function get (id) {
  return httpAuth.get(`/tabeladesconto/${id}`, { tela: 'tabela_desconto' })
}

export async function add (dados) {
  return httpAuth.post(`/tabeladesconto`, dados, { funcionalidade: 'tabela_desconto_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/tabeladesconto/${id}`, dados, { funcionalidade: 'tabela_desconto_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/tabeladesconto/${id}`, { funcionalidade: 'tabela_desconto_excluir' })
}
